import React from "react"
import {
  CardHeader,
  CardBody,
  Row,
  Col,
  Form,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input
} from "reactstrap"
import moment from "moment"
import { FilePond, registerPlugin } from "react-filepond"
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation"
import FilePondPluginImagePreview from "filepond-plugin-image-preview"
import Datetime from "react-datetime"
import { Spinner } from "components/spinner"
import { BackButton } from "components/utility"
import { orderStatusTypes, findTypeValueByKey } from "utils/types"

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)

const optionsLevel = [
  { status: "PROCESSING", level: 0 },
  { status: "SUBMITTED", level: 1 },
  { status: "CONFIRMED", level: 2 },
  { status: "SUCCESS", level: 3 },
  { status: "CANCEL", level: 3 }
]

const OrderForm = ({
  orderStatus,
  data,
  status,
  setStatus,
  expectedDate,
  setExpectedDate,
  invoice,
  setInvoice,
  delivery,
  setDelivery,
  deliveryType,
  setDeliveryType,
  invoiceUrl,
  setInvoiceFile
}) => {
  const options = status => {
    const currentStatusLevel = optionsLevel?.find(item => item.status === status)?.level

    const filterStatus = optionsLevel?.filter(item => {
      if (currentStatusLevel !== 3) {
        if (currentStatusLevel === 1) {
          return (
            currentStatusLevel === item.level ||
            item.status === "CANCEL" ||
            item.status === "CONFIRMED"
          )
        }
        return item.level >= currentStatusLevel
      }
      return false
    })
      .map(item => item.status)

    return orderStatusTypes
      .filter(item => filterStatus.includes(item.key))
      .map(item => (
        <option key={item.key} value={item.key}>
          {item.value}
        </option>
      ))
  }

  if (!data) {
    return <Spinner />
  }

  return (
    <>
      <CardHeader>
        <Row style={{ display: "flex", alignItems: "center" }}>
          <Col>
            <BackButton left />
          </Col>
        </Row>
      </CardHeader>

      <CardBody className="pb-1">
        <Form
          style={{
            marginLeft: "10px",
            marginRight: "10px"
          }}
        >
          <Row>
            <Col sm={12} lg={6} className="mb-2">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>巨研訂單編號</InputGroupText>
                </InputGroupAddon>
                <Input
                  readOnly
                  value={data?.order?.orderNumber || "未成立之訂單"}
                />
              </InputGroup>
            </Col>
            <Col sm={12} lg={6} className="mb-2">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>訂單擁有者</InputGroupText>
                </InputGroupAddon>
                <Input
                  readOnly
                  value={`${data.order?.company?.name} - ${data.order?.user?.name}`}
                />
              </InputGroup>
            </Col>

            <Col sm={12} lg={6} className="mb-2">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>訂單狀態</InputGroupText>
                </InputGroupAddon>
                <Input
                  type="select"
                  name="status"
                  id="status"
                  value={status}
                  onChange={e => setStatus(e.target.value)}
                  disabled={status === "PROCESSING"}
                >
                  {options(orderStatus).length === 0 ? (
                    <option key={orderStatus} value={orderStatus}>
                      {findTypeValueByKey(orderStatusTypes, orderStatus)}
                    </option>
                  ) : (
                    options(orderStatus)
                  )}
                </Input>
              </InputGroup>
            </Col>

            <Col sm={12} lg={6} className="mb-2">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>使用者送出時間</InputGroupText>
                </InputGroupAddon>

                <Datetime
                  dateFormat="YYYY-MM-DD a h:mm"
                  timeFormat={true}
                  closeOnSelect={true}
                  closeOnTab={true}
                  value={
                    data.order?.processTime
                      ? moment(data.order?.processTime).format(
                        "YYYY-MM-DD a h:mm"
                      )
                      : ""
                  }
                  inputProps={{
                    placeholder: "使用者送出時間",
                    disabled: true
                  }}
                />
              </InputGroup>
            </Col>
            <Col sm={12} lg={6} className="mb-2">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>同意送出時間</InputGroupText>
                </InputGroupAddon>

                <Datetime
                  dateFormat="YYYY-MM-DD a h:mm"
                  timeFormat={true}
                  closeOnSelect={true}
                  closeOnTab={true}
                  value={
                    data.order?.submittedTime
                      ? moment(data.order?.submittedTime).format(
                        "YYYY-MM-DD a h:mm"
                      )
                      : ""
                  }
                  inputProps={{
                    placeholder: "同意送出時間",
                    disabled: true
                  }}
                />
              </InputGroup>
            </Col>
            <Col sm={12} lg={6} className="mb-2">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>訂單確認時間</InputGroupText>
                </InputGroupAddon>

                <Datetime
                  dateFormat="YYYY-MM-DD a h:mm"
                  timeFormat={true}
                  closeOnSelect={true}
                  closeOnTab={true}
                  value={
                    data.order?.confirmedTime
                      ? moment(data.order?.confirmedTime).format(
                        "YYYY-MM-DD a h:mm"
                      )
                      : ""
                  }
                  inputProps={{
                    placeholder: "訂單確認時間",
                    disabled: true
                  }}
                />
              </InputGroup>
            </Col>
            <Col sm={12} lg={6} className="mb-2">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>訂單完成時間</InputGroupText>
                </InputGroupAddon>

                <Datetime
                  dateFormat="YYYY-MM-DD a h:mm"
                  timeFormat={true}
                  closeOnSelect={true}
                  closeOnTab={true}
                  value={
                    data.order?.successTime
                      ? moment(data.order?.order?.successTime).format(
                        "YYYY-MM-DD a h:mm"
                      )
                      : ""
                  }
                  inputProps={{
                    placeholder: "訂單完成時間",
                    disabled: true
                  }}
                />
              </InputGroup>
            </Col>
            <Col sm={12} lg={6} className="mb-2">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>訂單取消時間</InputGroupText>
                </InputGroupAddon>

                <Datetime
                  dateFormat="YYYY-MM-DD a h:mm"
                  timeFormat={true}
                  closeOnSelect={true}
                  closeOnTab={true}
                  value={
                    data.order?.cacelTime
                      ? moment(data.order?.cacelTime).format(
                        "YYYY-MM-DD a h:mm"
                      )
                      : ""
                  }
                  inputProps={{
                    placeholder: "訂單取消時間",
                    disabled: true
                  }}
                />
              </InputGroup>
            </Col>
            <Col sm={12} lg={6} className="mb-2">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>發票編號</InputGroupText>
                </InputGroupAddon>
                <Input
                  type="text"
                  name="invoice"
                  id="invoice"
                  placeholder="發票編號"
                  value={invoice || ""}
                  onChange={e => setInvoice(e.target.value)}
                />
              </InputGroup>
            </Col>
            <Col sm={12} lg={6} className="mb-2">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>宅配單號</InputGroupText>
                </InputGroupAddon>
                <Input
                  type="text"
                  name="delivery"
                  id="delivery"
                  placeholder="宅配單號"
                  value={delivery || ""}
                  onChange={e => setDelivery(e.target.value)}
                />
              </InputGroup>
            </Col>
            <Col sm={12} lg={6} className="mb-2">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>公司訂單號碼</InputGroupText>
                </InputGroupAddon>
                <Input
                  type="text"
                  name="title"
                  id="title"
                  disabled={true}
                  placeholder="公司訂單號碼"
                  value={data.order?.clientOrderNumber || ""}
                />
              </InputGroup>
            </Col>
            <Col sm={12} lg={6} className="mb-2">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>預期到貨日期</InputGroupText>
                </InputGroupAddon>

                <Datetime
                  dateFormat="YYYY-MM-DD"
                  timeFormat={false}
                  closeOnSelect={true}
                  closeOnTab={true}
                  value={
                    expectedDate
                      ? moment(expectedDate).format("YYYY-MM-DD")
                      : ""
                  }
                  onChange={date => setExpectedDate(date.format("YYYY-MM-DD"))}
                  inputProps={{
                    placeholder: "預期到貨日期",
                    disabled: status !== "CONFIRMED"
                  }}
                />
              </InputGroup>
            </Col>
            <Col sm={12} className="mb-2">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>貨品出貨方式</InputGroupText>
                </InputGroupAddon>
                <div className="mt-2 ml-2">
                  <div className="form-check">
                    <label>
                      <input
                        type="radio"
                        value="WITH_RECEIPT"
                        checked={deliveryType === "WITH_RECEIPT"}
                        onChange={e => setDeliveryType(e.target.value)}
                        className="form-check-input"
                      />
                      請隨貨開立發票
                    </label>
                  </div>

                  <div className="form-check">
                    <label>
                      <input
                        type="radio"
                        value="WITHOUT_RECEIPT"
                        checked={deliveryType === "WITHOUT_RECEIPT"}
                        onChange={e => setDeliveryType(e.target.value)}
                        className="form-check-input"
                      />
                      貨品先出，發票等通知開立
                    </label>
                  </div>
                </div>
              </InputGroup>
            </Col>
            <Col sm={12} className="mb-2">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>電子發票</InputGroupText>
                </InputGroupAddon>
                <div className="mt-2 ml-2" style={{ width: "250px" }}>
                  {invoiceUrl && (
                    <div className="mb-1">
                      <a
                        href={`http://VIP.getech.com.tw:6000/download?file=http://${invoiceUrl}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        下載電子發票
                      </a>
                    </div>
                  )}
                  <div>
                    <FilePond
                      labelIdle='將檔案拖拉至此 或 <span class="filepond--label-action">瀏覽檔案</span>'
                      allowMultiple={false}
                      beforeAddFile={item => {
                        return new Promise(resolve => {
                          setInvoiceFile(item.file)
                          return resolve(true)
                        })
                      }}
                      beforeRemoveFile={() => {
                        setInvoiceFile(null)
                      }}
                    />
                  </div>
                </div>
              </InputGroup>
            </Col>
          </Row>
        </Form>
      </CardBody>
    </>
  )
}

export default OrderForm
